(function () {
    'use strict';

    angular
        .module('app.paymentGateways')
        .controller('PaymentGatewayListController', PaymentGatewayListController);

    PaymentGatewayListController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function PaymentGatewayListController(common, dataservice) {
        var vm = this;

        vm.title = 'Payment Gateways';
        vm.displayedItems = [];
        vm.items = [];
        vm.isLoading = true;
        vm.isLicenseValid = false;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = vm.licenseInfo.NumberOfPaymentTemplatesLicensed >= vm.licenseInfo.NumberOfPaymentTemplatesInUse;
                return vm.licenseInfo;
            }, function (error) { });
        }

     
        function getItems() {
            return dataservice.getItems('api/PaymentGateways').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }
    }
})();
